import axios from '@/plugins/axios'
import { useStore, Module } from 'vuex'

const store = useStore()

const clearbitModule: Module<any, any> = {
    state: {},

    actions: {
        async getCompanySuggestions({ commit }, query) {
            let data = null
            const url =
                'https://web.api.socialhp.com/autocomplete/all/' +
                query

            const headers = {}

            if (sessionStorage.getItem('impersonating') && sessionStorage.getItem('impersonatingWorkspace')) {
                headers['X-Switch-User'] = sessionStorage.getItem('impersonating')
                headers['X-Switch-User-Workspace'] = sessionStorage.getItem('impersonatingWorkspace')
            }

            await axios
                .get(url, { withCredentials: false, headers: headers })
                .then((response) => {
                    data = response.data
                })

            return data
        },
    },

    mutations: {},
}

export default clearbitModule
